// project imports
import * as actionTypes from "./actions";

export const initialState = {
  model: {},
};

const newJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SELECT_MODEL:
      return {
        ...state,
        model: action.value, // 将 action.value 设置为 model 的值
      };
    default:
      return state;
  }
};

export default newJobReducer;
